module.exports = __webpack_public_path__ + "ba.svg?7d6f56d23d025c0f0368ac2f85d7f8af";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/ba.svg
// module id = 987
// module chunks = 0